import { EditorSteps } from '../../constants';
import type { StepWithCondition } from '../../hooks/useTileEditorSteps';
import { AnalyticsQueryEditor } from '../../analytics/AnalyticsQueryEditor';

interface UseQueryStepParameters {
    isEditingSQL: boolean;
}

const QueryStepSublabel: React.FC = () => {
    return <span>Enter your query</span>;
};

/**
 * Create an object representing a query step.
 */
export const useQueryStep = ({
    isEditingSQL
}: UseQueryStepParameters): StepWithCondition => {
    const isEnabled = isEditingSQL;

    return {
        name: EditorSteps.query,
        isEnabled,
        Sublabel: QueryStepSublabel,
        sublabelProps: {},
        Content: AnalyticsQueryEditor,
        contentProps: {}
    };
};